import { PROPOSALS_ENDPOINT } from "../constants/endpoints";
import { request, ResponseProps } from "./request";
import axios from "axios";

export const getAllProposals = async (
  isAll: boolean,
  productCode: string,
  page: number,
  size: number
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${PROPOSALS_ENDPOINT}?isAll=${isAll}&productCode=${productCode}&page=${page}&size=${size}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const previewRFQ = async (
  proposalId: string,
  productTitle: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}/insurpro-backend/v1/generate-rfq-preview?proposalId=${proposalId}&&productTitle=${productTitle}`
  );

  if (r.success) {
    const apiData = r.data;
    return { success: r.success, data: apiData, message: r.message };
  }

  return { success: false, data: r?.data, message: r.message };
};

export const previewEmailQCR = async (
  proposalId: string,
  productTitle: string,
  isEmail: boolean
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}/insurpro-backend/v1/generate-qcr?proposalId=${proposalId}&&productTitle=${productTitle}&&isEmail=${isEmail}`
  );

  if (r.success) {
    const apiData = r.data;
    return { success: r.success, data: apiData, message: r.message };
  }

  return { success: false, data: r?.data, message: r.message };
};

export const generateRFQ = async (
  body
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: ResponseProps = (await request.postForm(
    `${sessionStorage.getItem("gatewayURL")}/insurpro-backend/v1/generate-rfq`,
    body
  )) as ResponseProps;

  if (r.success) {
    return { success: r.success, data: r.data, message: r.message };
  }

  return { success: false, data: r.data, message: r.message };
};

export const generateQCR = async (
  body
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: ResponseProps = (await request.postForm(
    `${sessionStorage.getItem("gatewayURL")}/insurpro-backend/v1/generate-qcr`,
    body
  )) as ResponseProps;

  if (r.success) {
    return { success: r.success, data: r.data, message: r.message };
  }

  return { success: false, data: r.data, message: r.message };
};

export const uploadHistoricData = async (file, setProgress) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${sessionStorage.getItem(
        "gatewayURL"
      )}/insurpro-backend/v1/upload-existing`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("react-token")}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      }
    );
    console.log(response);
    if (response?.data?.success) {
      return {
        success: response?.data?.success,
        data: response?.data?.data,
        message: response?.data?.message,
      };
    } else {
      return {
        success: false,
        data: null,
        message: "Failed to upload file due to server error.",
      };
    }
  } catch (error) {
    console.log("Error during file upload:", error);
    return { success: false, message: "Error during file upload." };
  }
};
